var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.548 19.69c9.056 0 14.01-7.503 14.01-14.01 0-.213 0-.425-.014-.635A10 10 0 0 0 24 2.493a9.8 9.8 0 0 1-2.828.776A4.94 4.94 0 0 0 23.336.545 9.9 9.9 0 0 1 20.21 1.74 4.928 4.928 0 0 0 11.82 6.23 13.98 13.98 0 0 1 1.67 1.087a4.927 4.927 0 0 0 1.524 6.572A4.9 4.9 0 0 1 .96 7.045v.062a4.926 4.926 0 0 0 3.95 4.827 4.9 4.9 0 0 1-2.223.084 4.93 4.93 0 0 0 4.6 3.42A9.88 9.88 0 0 1 0 17.478a13.94 13.94 0 0 0 7.548 2.208"
  })));
};
export default SvgTwitter;